import React, { useRef, useEffect } from 'react';
import classes from './NotificationDropdown.module.scss';
import { getTimeDifference } from '../../../helper/utils';

const NotificationDropdown = ({ 
    notifications, 
    onClose, 
    onNotificationClick, 
    onMarkAllRead,
    isMobile 
}) => {
    const dropdownRef = useRef(null);
    const unreadCount = notifications.filter(notif => !notif.isRead).length;

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    if(isMobile) {
        return (
            <div className={classes.mobileOverlay} onClick={(e) => {
                if (e.target === e.currentTarget) onClose();
            }}>
                <div className={classes.mobileNotifications} ref={dropdownRef}>
                    <div className={classes.mobileHeader}>
                        <span>Notifications</span>
                        <button onClick={onClose} className={classes.closeButton}>
                            ×
                        </button>
                    </div>
                    <div className={classes.mobileContent}>
                        {notifications.length === 0 ? (
                            <div className={classes.emptyState}>
                                <i 
                                    className="fa-solid fa-bell-slash fa-2xl" 
                                    style={{ 
                                        color: "#7d61f0",
                                        fontSize: "48px",
                                        marginBottom: "16px"
                                    }}
                                ></i>
                                <p>No Notifications</p>
                            </div>
                        ) : (
                            <ul className={classes.mobileList}>
                                {notifications.map((notification, index) => (
                                    <React.Fragment key={notification.id}>
                                        <li 
                                            className={`${classes.mobileItem} ${!notification.isRead ? classes.unread : ''}`}
                                            onClick={() => onNotificationClick(notification)}
                                        >
                                            {!notification.isRead && <span className={classes.unreadDot} />}
                                            <span className={classes.message}>{notification.message}</span>
                                            <span className={classes.time}>
                                                {getTimeDifference(notification.createdAt)}
                                            </span>
                                        </li>
                                        {index < notifications.length - 1 && <div className={classes.divider} />}
                                    </React.Fragment>
                                ))}
                            </ul>
                        )}
                    </div>
                    {notifications.length > 0 && (
                        <div className={classes.mobileFooter}>
                            <button 
                                className={classes.mobileMarkReadBtn}
                                onClick={onMarkAllRead}
                                disabled={unreadCount === 0}
                                style={{ 
                                    opacity: unreadCount === 0 ? 0.5 : 1,
                                    cursor: unreadCount === 0 ? 'not-allowed' : 'pointer'
                                }}
                            >
                                Mark all as read
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }
    return (
        <div className={classes.dropdown} ref={dropdownRef}>
            <div className={classes.header}>
                <span>Notifications</span>
            </div>
            {notifications.length === 0 ? (
                <div className={classes.emptyState}>
                    <i 
                        className="fa-regular fa-bell-slash fa-2xl" 
                        style={{ 
                            color: "#d1d1d1",
                            transform: "scale(2)",
                            display: "block",
                            marginBottom: "24px"
                        }}
                    ></i>
                    <p>No Notifications</p>
                </div>
            ) : (
                <>
                    <ul className={classes.list}>
                        {notifications.map((notification, index) => (
                            <React.Fragment key={notification.id}>
                                <li 
                                    className={`${classes.item} ${notification.isUnread ? classes.unread : ''}`}
                                    onClick={() => onNotificationClick(notification)}
                                >
                                    {!notification.isRead && <span className={classes.unreadDot} />}
                                    <span className={classes.message}>{notification.message}</span>
                                    <span className={classes.time}>{
                                        getTimeDifference(notification.createdAt)
                                    }</span>
                                </li>
                                {index < notifications.length - 1 && <div className={classes.divider} />}
                            </React.Fragment>
                        ))}
                    </ul>
                    
                        <button 
                            className={classes.markReadBtn}
                            onClick={unreadCount>0 ? onMarkAllRead : null}
                        >
                            {unreadCount > 0 && (
                            "Mark all as read")}
                        </button>
                    
                </>
            )}
        </div>
    );
};

export default NotificationDropdown;
